// extracted by mini-css-extract-plugin
module.exports = {"wrapperMain":"style-module__wrapperMain___tRuT0","wrapperBtn":"style-module__wrapperBtn___MBXzw"};